<label>
  <input (change)="changeState($event)" type="checkbox" [checked]="checked" />
  <span class="sliderNew" [ngClass]='[checked ? colorClass : "bg-ccc", rebrandedUI ? "acq-rebranding-2025" : ""]'>
  </span>
</label>
